//export const apiURL = "http://kickhouse.local";
//export const apiURL = "https://thekickhouse.staging.wpengine.com";

//export const siteURL = "https://thekickhouse.staging.wpengine.com";
export const apiURL = "https://thekickhouse.com";
// export const apiURL = "https://thekhdev.wpengine.com";
export const siteURL = "https://thekickhouse.com";
export const ghlAPIURL = "https://rest.gohighlevel.com/v1";
export const ghlAPIKey = "04ee52c7-7170-4382-9dd9-984ffcabf264";
